module.exports = {"350923100":"古峰镇","350923101":"双溪镇","350923102":"黛溪镇","350923103":"长桥镇","350923200":"屏城乡","350923201":"棠口乡","350923202":"甘棠乡","350923203":"熙岭乡","350923204":"路下乡","350923205":"寿山乡","350923206":"岭下乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350923.json
// module id = 1240
// module chunks = 0